import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_LoggedIn/attendance/session/current')({
    loader: async ({ context }) => {
        try {
            // Use the QueryClient that we injected into the router context to run
            // the query in a type-safe way without needing React Query hooks.
            const session = await context.queryClient.fetchQuery(
                context.trpc.session.getCurrentSession.queryOptions()
            )

            if (!session?.id) {
                throw redirect({
                    to: '/attendance/session/new',
                    replace: true,
                })
            }

            throw redirect({
                to: '/attendance/session/$sessionId',
                params: { sessionId: session.id },
                replace: true,
            })
        } catch (error) {
            // If it's already a redirect, re-throw it
            if (error && typeof error === 'object' && 'to' in error) {
                throw error
            }

            // For other errors, redirect to the new session page
            throw redirect({
                to: '/attendance/session/new',
                replace: true,
            })
        }
    }
})
